@let selected = ac();
<app-drawer-layout
  [title]="selected ? selected.account.nickname || selected.account.name : 'Account'"
  [state]="layoutState()"
  errorMessage="We couldn't load this account. It may have been removed."
>
  <!-- Single-root @if blocks so each piece is projected into its header slot. -->
  @if (logoSrc(); as src) {
    <img
      drawerLeading
      class="block size-10 rounded-md border border-border-muted bg-surface-page object-contain"
      [src]="src"
      alt=""
    />
  }
  @if (selected) {
    <span drawerSubtitle class="flex flex-wrap items-center gap-x-2 gap-y-0.5">
      <span>{{ selected.credential.institution.name }}</span>
      @if (selected.account.mask) {
        <span class="font-mono tabular-nums tracking-wide text-text-subtle">••{{ selected.account.mask }}</span>
      }
    </span>
  }
  @if (selected) {
    <app-account-details
      [account]="selected.account"
      [credential]="selected.credential"
      (accountSaved)="closeDrawer()"
    />
  }
</app-drawer-layout>
